module.exports = __webpack_public_path__ + "static/media/Abivin logo transparent white.b22666ff.png";